<template>
  <div class="bigbox">
    <el-dialog title="生成人群" :visible.sync="isShow" width="600px" :before-close="update">
      <div style="
          background: #fafafa;
          padding: 10px;
          width: 90%;
          margin: 0 0 20px 25px;
        ">
        <img src="@/assets/images/new_icon_reminder.png" style="
            display: inline-block;
            float: left;
            width: 14px;
            height: 14px;
            color: #ffffff;
            margin: 0 4px 0px 3px;
          " />
        <p>生成的人群会保存在客户分群列表中</p>
      </div>
      <el-form :model="crowdForm">
        <el-form-item label="人群名称:" label-width="120px" required>
          <el-input v-model="crowdForm.name" style="width: 350px" maxlength="50" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="人群描述:" label-width="120px" required>
          <el-input v-model="crowdForm.description" style="width: 350px" maxlength="50" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" :loading="loading" @click="goMarketing()" style="width: 150px" v-preventReClick>
          生成人群并去营销
        </el-button>
        <el-button type="primary" :loading="loading" @click="generateCrowd()" v-preventReClick>
          确定生成
        </el-button>
        <el-button @click="update">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { generateCrowd } from "@/api/analysis/index";
import { mapState } from "vuex";
export default {
  name: "crowd-dialog",
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    label: { // 查看接口apifox说明
      type: String,
      default: "",
    },
    crowdTag: { // 人群标记
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
    }),
  },
  data() {
    return {
      loading: false,
      crowdForm: {
        name: '',
        description: '',
      },
      btnLoading: false,
    };
  },

  watch: {
    isShow(val) {
      if (val) {
        console.log('this.crowdTag------>', this.crowdTag)
        console.log('this.label------>', this.label)
        this.crowdForm.name = this.crowdForm.description =  this.$route.meta.name + " " + this.$getNowDate("", false)
      }
    }
  },

  methods: {
    //生成人群并去营销
    goMarketing() {
      if (!this.crowdForm.name) {
        this.$message.warning("人群名称不能为空");
        return;
      }
      if (!this.crowdForm.description) {
        this.$message.warning("人群描述不能为空");
        return;
      }
      const obj = {
        ...this.crowdForm,
        crowdTag: this.crowdTag,
        label: this.label,
        type: this.$route.meta.name == "客户资产分析" ? 0 : this.$route.meta.name == "客户价值分析" ? 1 : 2,
      }
      this.loading = true
      generateCrowd(obj)
        .then((res) => {
          this.loading = false
          if (res && res.code == 1) {
            this.$message.success("生成成功");
            this.update();
            window.localStorage.setItem("strategy", JSON.stringify(res.data));
            let routeUrl = this.$router.resolve({
              path: "../../marketing/marketing/accurate_market",
              query: {
                preId: res.data.precisionCrowdStrategyId,
              },
            });
            window.open(routeUrl.href, "_blank");
          } else if (res) {
            this.$message.error(res.message);
          }
        })
        .catch((res) => {
          this.loading = false
          this.$message.error(res.message);
        });
    },

    //确定生成
    generateCrowd() {
      if (!this.crowdForm.name) {
        this.$message.warning("人群名称不能为空");
        return;
      }
      if (!this.crowdForm.description) {
        this.$message.warning("人群描述不能为空");
        return;
      }
      const obj = {
        ...this.crowdForm,
        crowdTag: this.crowdTag,
        label: this.label,
        type: this.$route.meta.name == "客户资产分析" ? 0 : this.$route.meta.name == "客户价值分析" ? 1 : 2,
      }
      this.loading = true
      generateCrowd(obj)
        .then((res) => {
          this.loading = false;
          if (res && res.code == 1) {
            this.$message.success("生成成功");
            this.update();
          } else if (res) {
            this.$message.error(res.message);
          }
        })
        .catch((res) => {
          this.loading = false;
          this.$message.error(res.message);
        });
    },

    update() {
      this.$emit("update:isShow", !this.isShow)
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-form-item__error {
  display: none;
}
</style>
